import http from './axios'
import * as md5 from './md5.js';
const url = ''
export function getDate(data) {
  return http({
    url: '/system/dict/data/type/map',
    method: 'get',
    params: data
  })
}
export function getNewsDate(data) {
  return http({
    url: '/website/resource',
    method: 'get',
    params: data
  })
}
export function getNewsDatebyId(data) {
  return http({
    url: '/website/resource/' + data,
    method: 'get',
  })
}
export function getWebsite(query) {
  return http({
    url: '/website/resource',
    method: 'get',
    params: query
  })
}

export function submitComment(query) {
  return http({
    url: '/website/comment',
    method: 'post',
    data: query
  })
}
export function getHallStatistic() {
  return http({
    url: '/hall/statistic',
    method: 'get'
  })
}
export function getHallToday() {
  return http({
    url: '/hall/today',
    method: 'get'
  })
}
export function getHallWall(query) {
  return http({
    url: '/hall/wall',
    method: 'get',
    params: query
  })
}
export function getHallHuman(query) {
  return http({
    url: '/hall/human',
    method: 'get',
    params: query
  })
}

// 领取大礼包
export function contactUs(query) {
  return http({
    url: '/contactUs/save',
    method: 'post',
    data: query
  })
}
// 验证码

export function smsCode(query) {
  const sign = md5.hex_hmac_md5('U78dVNzeFwDZ&qei', JSON.stringify(query))
  query.sign = sign
  return http({
    url: '/api/security/smscode',
    method: 'post',
    data: query
  })
}
//登录校验
export function checkLogin() {
  return http({
    url: '/api/security/check_login',
    method: 'post',
  })
}
//登录校验
export function validate(query) {
  return http({
    url: '/api/security/smscode/validate',
    method: 'post',
    params: query
  })
}
//登录
export function loginSms(query) {
  return http({
    url: '/api/security/zxjspcLoginBySms',
    method: 'post',
    data: query
  })
}
//登录
export function getMyBaseInfo() {
  return http({
    url: '/app/personalCenter/getMyBaseInfo',
    method: 'GET'
  })
}

//纪念堂礼物
export function getGiftsOnline(query) {
  return http({
    url: '/online_sacrifice/gifts/online',
    method: 'GET',
    params: query
  })
}
//纪念堂礼物送出总数
export function getGiftsHall(query) {
  return http({
    url: '/hall/gift',
    method: 'GET',
    params: query
  })
}

export function styleList(data) {
  return http({
    url: '/online_sacrifice/style/hallQuery',
    method: 'post',
    data: data
  })
}

export function styleSet(data) {
  return http({
    url: '/online_sacrifice/style/set',
    method: 'post',
    data: data
  })
}
//纪念堂详情
export function getHallatta(query) {
  return http({
    url: '/v1/atta/hall',
    method: 'GET',
    params: query
  })
}
//纪念堂生平
export function getHalldetail(query) {
  return http({
    url: '/hall/detail',
    method: 'GET',
    params: query
  })
}
export function getVideoById(query) {
  return http({
    url: `/api/video/${query}`,
    method: 'GET'
  })
}



export function orderPre(data) {
  return http({
    url: '/order/create',
    method: 'post',
    data: data
  })
}

export function orderQueryStatus(id) {
  return http({
    url: '/order/queryPayStatus/' + id,
    method: 'post',
  })
}
export function sendGift(data) {
  return http({
    url: 'online_sacrifice/gift',
    method: 'post',
    data: data,
  })
}

export function getDictTypeMap(type) {
  return http({
    url: '/system/dict/data/type/map',
    method: 'get',
    params: {
      dictType: type
    }
  })
}
export function getDictTypeDate(type) {
  return http({
    url: '/system/dict/data/type/' + type,
    method: 'get'
  })
}
// 留言信息
export function getLeaveMessage(query) {
  return http({
    url: '/online_sacrifice/leave_message',
    method: 'GET',
    params: query
  })
}
// 留言弹幕
export function getDanmu(query) {
  return http({
    url: '/online_sacrifice/danmu',
    method: 'GET',
    params: query
  })
}
//发送弹幕
export function toLeaveMessage(query) {
  return http({
    url: '/online_sacrifice/leave_message',
    method: 'post',
    data: query
  })
}

// 删除留言
export function delLeaveMessage(query) {
  return http({
    url: '/online_sacrifice/leave_message',
    method: 'DELETE',
    params: query
  })
}
//
export function actionAll(query) {
  return http({
    url: '/action',
    method: 'post',
    data: query
  })
}

// 编辑纪念馆
export function editHall(data) {
  return http({
    url: '/hall/app/hall',
    method: 'post',
    data: data
  })
}
//设置纪念馆相框
export function tabletStyleSet(id, styleId) {
  return http({
    url: '/hall/tabletStyle/' + id + '/' + styleId,
    method: 'post',
  })
}
// 查询支持快速建馆
export function getDieMember() {
  return http({
    url: '/hall/genealogy_die_members',
    method: 'GET',
  })
}
// 免费建馆
export function addMemberHall(data) {
  return http({
    url: '/hall/member',
    method: 'post',
    data: data
  })
}
// 快速建馆
export function addSyncHall(data) {
  return http({
    url: '/hall/member_sync',
    method: 'post',
    data: data
  })
}
//礼物
export function getGiftDie(query) {
  return http({
    url: '/hall/gift/view',
    method: 'GET',
    params: query
  })
}

// 编辑个人资料
export function updateMyBaseInfo(data) {
  return http({
    method: 'POST',
    url: `/app/personalCenter/updateMyBaseInfo`,
    data: data
  })
}
// 反馈
export function addFeedback(data) {
  return http({
    method: 'POST',
    url: `/feedback/add`,
    data: data
  })
}
// 删除纪念馆
export function delHall(query) {
  return http({
    url: '/hall/admin/hall',
    method: 'DELETE',
    params: query
  })
}

// 在线祭祀搜索接口

export function getSearch(query) {
  return http({
    url: '/hall/human/search',
    method: 'GET',
    params: query
  })
}

// 申请纪念馆
export function applyMemberHalls(data) {
  return http({
    url: '/hall/apply',
    method: 'post',
    data: data
  })
}
//新祭品放桌子
export function getGiftTable(query) {
  return http({
    url: '/hall/gift/view/list',
    method: 'GET',
    params: query
  })
}
export function getGiftList(query) {
  return http({
    url: '/hall/gift/view/list/record',
    method: 'GET',
    params: query
  })
}
//送礼物列表
export function getGiftType(data) {
  return http({
    url: '/hall/giftType/page',
    method: 'post',
    data: data
  })
}
//关注的纪念馆
export function getHumanFocus(query) {
  return http({
    url: 'hall/humanFocus',
    method: 'GET',
    params: query
  })
}
//获取名人纪念馆tap
export function getTapType(data) {
  return http({
    url: 'hall/type/page',
    method: 'post',
    data: data
  })
}
//获取快速祭拜礼物
export function getQuickGift(query) {
  return http({
    url: 'hall/gift/quick',
    method: 'GET',
    params: query
  })
}
//快速祭拜送礼物
export function toQuickGift(data) {
  return http({
    url: 'hall/gift/quick',
    method: 'POST',
    data: data
  })
}
//祭拜排行榜 /hall/gift/rank?id=xxx
export function getGiftrank(query) {
  return http({
    url: 'hall/gift/rank',
    method: 'GET',
    params: query
  })
}
//快速建馆族谱列表
export function getGenealogyList(query) {
  return http({
    url: '/hall/quick_create_genealogy',
    method: 'GET',
    params: query
  })
}
//快速建馆族谱列表人员
export function getGenealogyListMembers(query) {
  return http({
    url: '/hall/genealogy_die_members_page',
    method: 'GET',
    params: query
  })
}

// 举报理由列表
export function reportfList(dictType) {
  return http({
    url: '/system/dict/data/type/' + dictType,
    method: 'GET',
  })
}

//举报提交
export function reportSubmit(data) {
  return http({
    url: '/action',
    method: 'POST',
    data: data
  })
}
export function getHallTypePage(data) {
  return http({
    url: '/hall/type/page',
    method: 'POST',
    data: data
  })
}
//绑定invitecode
export function bindCode(data) {
  return http({
    url: '/proxy/bind',
    method: 'POST',
    data: data
  })
}
//私人馆列表
export function getPrivateHall(query) {
  return http({
    url: '/hall/private_hall',
    method: 'GET',
    params: query
  })
}
//获取首页轮播图
export function bannerPicAppQuery(type) {
  return http({
    url: `/bannerPic/appQuery/${type}`,
    method: 'GET',
  })
}
//获取首页活动区域
export function getActiveArea(data) {
  return http({
    url: `/navTab/getActiveArea`,
    method: 'POST',
  })
}
//获取首页导航区域
export function navTabAppList(data) {
  return http({
    url: `/navTab/appList`,
    method: 'POST',
  })
}
//陵园列表
export function getCemetery(query) {
  return http({
    url: '/hall/cemetery',
    method: 'GET',
    params: query
  })
}
//
export function toaddCartList(data) {
  return http({
    url: `/hall/cart`,
    method: 'POST',
    data: data
  })
}
//购物车列表
export function getCartList(query) {
  return http({
    url: '/hall/cart',
    method: 'GET',
    params: query
  })
}
//购物车数量
export function getCartCount(query) {
  return http({
    url: '/hall/cart/count',
    method: 'GET',
    params: query
  })
}
// 删除购物车
export function delCartItem(query) {
  return http({
    url: '/hall/cart',
    method: 'DELETE',
    params: query
  })
}
//购物车记录
export function getCartListforme(query) {
  return http({
    url: '/hall/gift/record',
    method: 'GET',
    params: query
  })
}
//购物车免费礼物同时
export function toCartGiftforFree(data) {
  return http({
    url: `/online_sacrifice/cart/gift`,
    method: 'POST',
    data: data
  })
}
//查询馆内香火值
export function getSpecialCount(query) {
  return http({
    url: '/action/special_count',
    method: 'GET',
    params: query
  })
}
//河灯我的列表
export function getRiverRecord(query) {
  return http({
    url: '/hall/gift/view/list/river_record',
    method: 'GET',
    params: query
  })
}